import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentContentWidget = ({ contentItems }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'published':
        return 'text-success bg-success/10';
      case 'draft':
        return 'text-warning bg-warning/10';
      case 'scheduled':
        return 'text-primary bg-primary/10';
      case 'archived':
        return 'text-muted bg-muted';
      default:
        return 'text-muted bg-muted';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Recent Content</h3>
          <p className="text-xs md:text-sm text-muted-foreground">Latest updates and drafts</p>
        </div>
        <Button
          variant="ghost"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => navigate('/content-editor')}
        >
          View All
        </Button>
      </div>
      <div className="space-y-3 md:space-y-4">
        {contentItems?.map((item, index) => (
          <div 
            key={index} 
            className="flex items-start gap-3 p-3 hover:bg-muted/50 rounded-lg transition-colors duration-200 cursor-pointer"
            onClick={() => navigate('/content-editor')}
          >
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-2">
                <h4 className="text-xs md:text-sm font-medium text-foreground line-clamp-2">{item?.title}</h4>
                <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 ${getStatusColor(item?.status)}`}>
                  {item?.status}
                </span>
              </div>
              
              <div className="flex items-center gap-3 md:gap-4 text-xs text-muted-foreground flex-wrap">
                <div className="flex items-center gap-1">
                  <Icon name="Calendar" size={12} />
                  <span>{formatDate(item?.lastModified)}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="User" size={12} />
                  <span>{item?.author}</span>
                </div>
                {item?.views && (
                  <div className="flex items-center gap-1">
                    <Icon name="Eye" size={12} />
                    <span>{item?.views?.toLocaleString()}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentContentWidget;